export default __webpack_public_path__ + "static/media/Сургуулийн_өмнөх_болон_бага,_дунд_боловсролын,_мэргэжлийн_боловсролын.449ad2f6.pdf";